import React, { Suspense } from 'react';
import { HashRouter } from 'react-router-dom';
import { PessoaProvider } from './contexts/PessoaContext';

// NOVO IMPORT: Provider de Autenticação
import { AuthProvider } from './contexts/AuthContext';

// Provider de Oração
import { OraçãoProvider } from './contexts/OraçãoContext';

// ADICIONADO: Provider de Visitas
import { VisitaProvider } from './contexts/VisitaContext';

import AppRoutes from './routes/AppRoutes';
import ErrorBoundary from './components/ErrorBoundary';
import LoadingSpinner from './components/LoadingSpinner';
import './index.css';

function App() {
  return (
    <ErrorBoundary>
      {/* O AuthProvider fica por fora para gerenciar a sessão globalmente */}
      <AuthProvider>
        {/* Adicionamos o OraçãoProvider para envolver o resto da aplicação */}
        <OraçãoProvider>
          {/* Adicionamos o VisitaProvider */}
          <VisitaProvider>
            <PessoaProvider>
              <HashRouter>
                <Suspense fallback={<LoadingSpinner />}>
                  <AppRoutes />
                </Suspense>
              </HashRouter>
            </PessoaProvider>
          </VisitaProvider>
        </OraçãoProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;